export default __webpack_public_path__ + "static/media/ErrorConnection.8fa4c1ab.svg";